/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonSubscriptionFull,
  PersonSubscriptionFullOptional,
  PersonSubscriptionFullMetaI,
  PersonSubscriptionFullTrackedI,
} from "./person-subscription-full";
import {
  PersonSubscriptionFullTracked,
  PersonSubscriptionFullMeta,
} from "./person-subscription-full";

/**
 *
 * @export
 * @interface PersonSubscriptionDTO
 */
export interface PersonSubscriptionDTOOptional extends PersonSubscriptionFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonSubscriptionDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionDTO
   */
  billingDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionDTO
   */
  billingCycle?: string;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonSubscriptionDTO
   */
  personId?: PersonRefOptional;
}

export interface PersonSubscriptionDTO
  extends PersonSubscriptionDTOOptional, PersonSubscriptionFull {
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonSubscriptionDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionDTO
   */
  billingDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionDTO
   */
  billingCycle: string;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonSubscriptionDTO
   */
  personId: PersonRef;
}

export interface PersonSubscriptionDTOTrackedI extends PersonSubscriptionFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonSubscriptionDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionDTO
   */
  billingDate?: Date;
  billingDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionDTO
   */
  billingCycle?: string;
  billingCycleIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonSubscriptionDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
}

transformDatesMap.set(
  "PersonSubscriptionDTO",
  function (model: PersonSubscriptionDTO) {
    if (typeof model.billingDate == "string")
      model.billingDate = new Date(model.billingDate);
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
  },
);

export type PersonSubscriptionDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: true
  //isDatetime: false
  billingDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  billingCycle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
}>;

export var PersonSubscriptionDTOMeta: PersonSubscriptionDTOMetaI =
  {} as PersonSubscriptionDTOMetaI;
PersonSubscriptionDTOMeta = typeMeta("PersonSubscriptionDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  billingDate: propertyMeta(
    "billingDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  billingCycle: propertyMeta(
    "billingCycle",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
});

const metaI = PersonSubscriptionDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonSubscriptionFullMeta]);
  metaI.isDeleted.inheritedFrom = PersonSubscriptionFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = PersonSubscriptionFullMeta.isNew;
  metaI.assignId.inheritedFrom = PersonSubscriptionFullMeta.assignId;
  metaI.billingDate.inheritedFrom = PersonSubscriptionFullMeta.billingDate;
  metaI.billingCycle.inheritedFrom = PersonSubscriptionFullMeta.billingCycle;
  metaI.personId.inheritedFrom = PersonSubscriptionFullMeta.personId;
});

export class PersonSubscriptionDTOTracked
  extends PersonSubscriptionFullTracked
  implements PersonSubscriptionDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  billingDate__I?: Date = undefined;
  billingDateIsSet: boolean = false;
  set billingDate(v: undefined | Date) {
    if (v !== undefined) {
      this.billingDate__I = v;
      this.billingDateIsSet = true;
    } else {
      this.billingDate__I = v || undefined;
      this.billingDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get billingDate() {
    return this.billingDate__I;
  }
  billingCycle__I?: string = undefined;
  billingCycleIsSet: boolean = false;
  set billingCycle(v: undefined | string) {
    if (v !== undefined) {
      this.billingCycle__I = v;
      this.billingCycleIsSet = true;
    } else {
      this.billingCycle__I = v || undefined;
      this.billingCycleIsSet = true;
    }
    this.changeTracker = true;
  }
  get billingCycle() {
    return this.billingCycle__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  constructor(config?: PersonSubscriptionDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();
  }
  assignFrom(
    config: PersonSubscriptionDTOOptional,
    options?: AssignOptions,
  ): PersonSubscriptionDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.billingDate &&
      this.billingDateApplyFilter(optionsRequired.filter)
    ) {
      this.billingDate = config.billingDate;
      if (optionsRequired.unassign) this.billingDateIsSet = false;
      else this.billingDateIsSet = true;
    }
    if (
      config.billingCycle &&
      this.billingCycleApplyFilter(optionsRequired.filter)
    ) {
      this.billingCycle = config.billingCycle;
      if (optionsRequired.unassign) this.billingCycleIsSet = false;
      else this.billingCycleIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonSubscriptionDTOTrackedI {
    const cloned = {} as PersonSubscriptionDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.billingDateIsSetDeep() &&
      this.billingDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.billingDateIsSet = true;
      cloned.billingDate = this.billingDate;
    } else {
      //cloned.billingDateIsSet = false
    }
    if (
      this.billingCycleIsSetDeep() &&
      this.billingCycleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.billingCycleIsSet = true;
      cloned.billingCycle = this.billingCycle;
    } else {
      //cloned.billingCycleIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonSubscriptionDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.billingDateApplyFilter(filter)) this.billingDateIsSet = false;

    if (!this.billingCycleApplyFilter(filter)) this.billingCycleIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionDTOMeta.isDeleted,
      PersonSubscriptionDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionDTOMeta.isNew,
      PersonSubscriptionDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionDTOMeta.assignId,
      PersonSubscriptionDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  billingDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionDTOMeta.billingDate,
      PersonSubscriptionDTOMeta,
      this.billingDate,
      this,
    );
  }
  billingDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.billingDateIsSet && this.billingDateApplyFilter(filter))
      return true;

    return false;
  }
  billingCycleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionDTOMeta.billingCycle,
      PersonSubscriptionDTOMeta,
      this.billingCycle,
      this,
    );
  }
  billingCycleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.billingCycleIsSet && this.billingCycleApplyFilter(filter))
      return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionDTOMeta.personId,
      PersonSubscriptionDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.billingDateIsSetDeep(filter)) return true;
    if (this.billingCycleIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
